module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('detail-layout', {
    ref: "layout",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "FormLayout",
      fn: function(props) {
        return [_c('b-form', {
          ref: "form",
          staticClass: "col-md-6 offset-md-2",
          attrs: {
            "autocomplete": "off"
          }
        }, [(_vm.dataValid) ? _c('div', [_c('detail-field', {
          attrs: {
            "label": "Short Name",
            "field": "shortname",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "label": "Name",
            "field": "name",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), (false) ? _c('detail-field', {
          attrs: {
            "label": "Registration Fee Amount",
            "field": "registration_fee_amount",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e(), _vm._v(" "), (false) ? _c('detail-field', {
          attrs: {
            "label": "Invoice Amount 1",
            "field": "invoice1_amount",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e(), _vm._v(" "), (false) ? _c('detail-field', {
          attrs: {
            "label": "Invoice Amount 2",
            "field": "invoice2_amount",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e(), _vm._v(" "), (false) ? _c('detail-field', {
          attrs: {
            "label": "Invoice Amount 3",
            "field": "invoice3_amount",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e(), _vm._v(" "), (false) ? _c('detail-field', {
          attrs: {
            "label": "Invoice Amount 4",
            "field": "invoice4_amount",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e(), _vm._v(" "), (false) ? _c('detail-field', {
          attrs: {
            "label": "Monthly Allowance",
            "field": "monthly_allowance_amount",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e()], 1) : _vm._e()])]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-883edfaa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Program/Detail.vue
// module id = 716
// module chunks = 1